import React from 'react';
import { BrowserRouter, Routes, Route, createRoutesFromChildren, matchRoutes } from 'react-router-dom';
import HomePage from './pages/Home';
import SocialLogins from './pages/SocialLogins';
import Registration from './pages/Registration';
import Dashboard from './pages/Dashboard';
import UploadProcess from './pages/UploadProcess';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AdminDashboard from './pages/AdminDashboard';
import InvoiceForm from './pages/InvoiceForm';
import Profile from './pages/Profile';
import TermsAndConditions from './pages/TermsAndConditions';
import CookieConsent from './components/CookieConsent';
import EmailVerification from './pages/EmailVerification';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import useLanguageSync from './hooks/useLanguageSync';

// Language synchronization wrapper component
const LanguageSyncWrapper = ({ children }) => {
  useLanguageSync(); // This will automatically update user language preferences
  return children;
};

// Enable v7 features
const router = {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true
  }
};

const App = () => {
  return (
    <BrowserRouter {...router}>
      <LanguageSyncWrapper>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="login" element={<SocialLogins />} />
          <Route path="register" element={<Registration />} />
          <Route path="verify-email" element={<EmailVerification />} />
          <Route path="forgot-password" element={<ForgotPassword />} />
          <Route path="reset-password" element={<ResetPassword />} />
          <Route path="terms" element={<TermsAndConditions />} />
          <Route 
            path="profile" 
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route
            path="process"
            element={
              <ProtectedRoute>
                <UploadProcess />
              </ProtectedRoute>
            }
          />
          <Route
            path="dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route 
            path="admin" 
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            } 
          />
          <Route 
            path="payment/success" 
            element={
              <ProtectedRoute>
                <PaymentSuccess />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="payment/cancel" 
            element={
              <ProtectedRoute>
                <PaymentCancel />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="invoice" 
            element={
              <ProtectedRoute>
                <InvoiceForm />
              </ProtectedRoute>
            }
          />
        </Routes>
        <CookieConsent />
      </LanguageSyncWrapper>
    </BrowserRouter>
  );
};

export default App;